const notification = {
  'enroll-to-slot-success': 'Poprawnie zapisano na wybrany termin',
  'enroll-to-slot-error': 'Wystąpił błąd podczas zapisywania na wybrany termin',
  'sign-off-from-visit-success': 'Poprawnie wypisano z wybranego terminu',
  'sign-off-from-visit-error': 'Wystąpił błąd podczas wypisywania z wybranego terminu'
};

export default notification;
